class ValidationMessages {
    static pleaseFix() {
        return ValidationMessages.en.pleaseFix;
    }
    static number() {
        return ValidationMessages.en.number;
    }
    static compareEqual() {
        return ValidationMessages.en.compareEqual;
    }
    static compareLessThan() {
        return ValidationMessages.en.compareLessThan;
    }
    static decimal() {
        return ValidationMessages.en.decimal;
    }
    static rangeNumber() {
        return ValidationMessages.en.rangeNumber;
    }
    static required() {
        return ValidationMessages.en.required;
    }
    static compareGreaterThan() {
        return ValidationMessages.en.compareGreaterThan;
    }
    static email() {
        return ValidationMessages.en.email;
    }
    static exact() {
        return ValidationMessages.en.exact;
    }
    static image() {
        return ValidationMessages.en.image;
    }
    static radio() {
        return ValidationMessages.en.radio;
    }
    static rangeString() {
        return ValidationMessages.en.rangeString;
    }
    static checkbox() {
        return ValidationMessages.en.checkbox;
    }
    static rangeFile() {
        return ValidationMessages.en.rangeFile;
    }
    static rangeDate() {
        return ValidationMessages.en.rangeDate;
    }
    static integer() {
        return ValidationMessages.en.integer;
    }
    static date() {
        return ValidationMessages.en.date;
    }
}
ValidationMessages.en = {
    pleaseFix: "Please correct the following before submitting:",
    number: "{0} must be a number",
    compareEqual: "{0} and {1} do not match",
    compareLessThan: "{0} must be less than {1}",
    decimal: "{0} must be a decimal number ex: 1.00",
    rangeNumber: "{0} must be between '{1}' and '{2}'",
    required: "{0} is required",
    compareGreaterThan: "{0} must be greater than {1}",
    email: "{0} must be a correct e-mail address. ex: abc@xyz.com.",
    exact: "{0} must be {1}",
    image: "{0} must be an image",
    radio: "Select at least one {0}",
    rangeString: "{0} must be between {1} and {2} characters long",
    checkbox: "{0} must be checked",
    rangeFile: "{0} file size must be between {1}KB and {2}KB",
    rangeDate: "{0} must be between '{1}' and '{2}'",
    integer: "{0} must be an integer",
    date: "{0} must be a correct date. ex: 4/12/2020 or Apr 12 2020",
};
export default ValidationMessages;
